import { render, staticRenderFns } from "./gb-ant-select-date-picker.vue?vue&type=template&id=58f72e50&"
import script from "./gb-ant-select-date-picker.vue?vue&type=script&lang=js&"
export * from "./gb-ant-select-date-picker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports